import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Card,
    CardBody,
    Button,
    CustomInput,
} from 'reactstrap';
import Switch from 'rc-switch';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { putAPI_Update_HideStats } from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';

export default function HideStats({ propertyId, property, onSave }) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [hideStatData, setHideStatsData] = useState({
        hideWebWidget: false,
        isHourlyConversation: true,
        isRegionalLevel: true
    });
    const [rateData, setRateData] = useState({
        averageDailyRate: 0,
        averageDailyRateUSD: 0,
        averageHourlyWageRate: 0,
        averageHourlyWageRateUSD: 0,
    });

    useEffect(() => {
        if (property !== undefined) {
            if (property.hideStats !== null) {
                setHideStatsData({
                    ...hideStatData,
                    hideWebWidget: property?.hideStats?.hideWebWidget ?? false,
                    isHourlyConversation: property?.hideStats?.isHourlyConversation ?? true,
                    isRegionalLevel: property?.hideStats?.isRegionalLevel ?? true
                });
            }
            if (property.averageDailyRate !== null && property.averageHourlyWageRate !== null && property?.averageDailyRateUSD !== null && property?.averageHourlyWageRateUSD !== null) {
                setRateData({
                    averageDailyRate: property?.averageDailyRate || 0,
                    averageDailyRateUSD: property?.averageDailyRateUSD || 0,
                    averageHourlyWageRate: property?.averageHourlyWageRate || 0,
                    averageHourlyWageRateUSD: property?.averageHourlyWageRateUSD || 0,
                });
            }
        }
    }, [property]);

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        if (type === 'checkbox') {
            setHideStatsData({
                ...hideStatData,
                [name]: checked,
            });
        } else {
            setRateData({
                ...rateData,
                [name]: parseFloat(value),
            });
        }
    };

    const handleSave = () => {
        const body = {
            ...rateData,
            hideStats: hideStatData,
            topics: property?.topics,
            updater: 'Admin',
        };
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_HideStats}/${propertyId}`,
            data: body,
        }).then((res) => {
            // console.log('49', res.data);
            if (
                res.data.HttpStatusCode !== undefined &&
                res.data.HttpStatusCode === 400 &&
                res.data.Messages !== undefined &&
                res.data.Messages !== null &&
                res.data.Messages.length > 0
            ) {
                setMsg(res.data.Messages);
                setOpen(true);
            } else {
                NotificationManager.success(
                    '',
                    'Hide Stats updated successfully',
                    3000,
                    null,
                    null,
                    'success'
                );
                setTimeout(() => {
                    onSave?.();
                }, 1000);
            }
        });
    };
    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody>
                    <div className="text-center">
                        <h6>Data Insights</h6>
                        <Separator className="mb-3" />
                    </div>
                    <Row className="">
                        <Colxx md={12} className="mt-2">
                            <div className="align-vertical-center">
                                <CustomInput
                                    key="hideWebWidget"
                                    type="checkbox"
                                    name="hideWebWidget"
                                    checked={hideStatData.hideWebWidget}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <span>Hide Web Widget Stats</span>
                                </CustomInput>
                            </div>
                        </Colxx>
                        <Colxx md={12} className="mt-2">
                            <div className="align-vertical-center">
                                <CustomInput
                                    key="isRegionalLevel"
                                    type="checkbox"
                                    name="isRegionalLevel"
                                    checked={hideStatData.isRegionalLevel}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <span>Show Regional Level Stats</span>
                                </CustomInput>
                            </div>
                        </Colxx>
                        <Colxx md={12} className="mt-2">
                            <div className="align-vertical-center">
                                <CustomInput
                                    key="isHourlyConversation"
                                    type="checkbox"
                                    name="isHourlyConversation"
                                    checked={hideStatData.isHourlyConversation}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <span>Show Hourly Conversation Stats</span>
                                </CustomInput>
                            </div>
                        </Colxx>
                        <Colxx md={12} className="mt-3">
                            <Label>Average Daily Room Rate
                                {property?.currency ? ` (${property.currency})` : ''}
                            </Label>
                            <Input
                                type="number"
                                min={0}
                                name="averageDailyRate"
                                value={rateData.averageDailyRate}
                                onChange={handleChange}
                            />
                        </Colxx>
                        <Colxx md={12} className="mt-3">
                            <Label>Average Daily Room Rate (USD)</Label>
                            <Input
                                type="number"
                                min={0}
                                name="averageDailyRateUSD"
                                value={rateData.averageDailyRateUSD}
                                onChange={handleChange}
                            />
                        </Colxx>

                        <Colxx md={12} className="mt-3">
                            <Label>Average Hourly Wage Rate
                                {property?.currency ? ` (${property.currency})` : ''}
                            </Label>
                            <Input
                                type="number"
                                min={0}
                                name="averageHourlyWageRate"
                                value={rateData.averageHourlyWageRate}
                                onChange={handleChange}
                            />
                        </Colxx>

                        <Colxx md={12} className="mt-3">
                            <Label>Average Hourly Wage Rate (USD)</Label>
                            <Input
                                type="number"
                                min={0}
                                name="averageHourlyWageRateUSD"
                                value={rateData.averageHourlyWageRateUSD}
                                onChange={handleChange}
                            />
                        </Colxx>
                        <Colxx md={12} className="mt-2">
                            <div className="mb-1 mt-4 ml-2 text-center">
                                <Button
                                    color="primary"
                                    size="xs"
                                    className="mt-1"
                                    onClick={() => handleSave()}
                                >
                                    Save
                                </Button>
                            </div>
                        </Colxx>
                    </Row>
                </CardBody>
            </Card>
            <Validation
                open={open}
                messages={msg}
                toggle={() => {
                    setOpen(!open);
                }}
            ></Validation>
        </Fragment>
    );
}
